<ul class="stepProgress">
    @for (step of steps; track step) {
        <li [class]="getClass(step)"
            helpTooltip
            [tooltipText]="step.title()"
            position="bottom"
            (click)="click(step)">
            @if (showStepName) {
                <span>{{ step.name }}</span>
            }
        </li>
    }
</ul>
